module.exports = __webpack_public_path__ + "static/media/WGS-1R.de81d8d1.jpg";